import { Component, HostListener } from '@angular/core';
import { NotificationDTO } from '../../models/NotificationDTO';
import { NotificationService } from '../../services/Notification.service';
import { trigger, state, style, transition, animate } from '@angular/animations';
import { Observable, Subscription } from 'rxjs';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { environment } from "src/environments/environment";

@Component({
  selector: 'app-nav-notifications',
  templateUrl: './nav-notifications.component.html',
  styleUrls: ['./nav-notifications.component.css'],
  animations: [
      trigger("mostrarNotificaciones", [
        state("visible", style({ opacity: 1, height: "*" })),
        state("hidden", style({ opacity: 0, height: "0px", overflow: "hidden", display: "none" })),
        transition("visible <=> hidden", animate("300ms ease-in-out")),
      ]),
    ],
})
export class NavNotificationsComponent {
  notificationList: NotificationDTO[] = [];


  public $notificationList: Observable<NotificationDTO[]> = new Observable<NotificationDTO[]>();
  public $notificationCount: Observable<number> = new Observable<number>();

  subscripcion_notificationList: Subscription;

  constructor(
    public notificationService: NotificationService,
    private toastrService: ToastrService,
    private router: Router
  ) {
    this.$notificationList = this.notificationService.getNotificationList();
    this.subscripcion_notificationList = this.$notificationList.subscribe((list) => {
      this.notificationList = list;
      
    });
  }

  ngOnDestroy(): void {
    if (this.subscripcion_notificationList) 
      this.subscripcion_notificationList.unsubscribe();
  }

  onNotificationClick(idAlarm: number, idNotification: number){
    if (idAlarm) {
      this.notificationService.NavBarNotificationClick(idAlarm, idNotification);
    }else{
      this.toastrService.error("No hay datos para abrir la notificación.");
      this.notificationService.deactivateNotificationById(idNotification);
    }
  }

  onScroll(event: any): void {
    const element = event.target;
    if (element.scrollHeight - element.scrollTop === element.clientHeight) {
      this.loadMoreNotifications();
    }
  }

  loadMoreNotifications(): void {
    // se obtiene la página de tal forma que si hay números residuales, se vuelva a pedir desde la página con los residuos incluidos, para evitar lapsos
    var page = 0;
    var length = this.notificationService.notificationList.length;
    var residue = length % 10;
    if (residue != 0) {
      page = Math.floor(length / 10);
      // si el numero de residuo es mayor a 0 pero el total menor a 10, dará 0, se suma 1 a la página para que se pida desde la primera
      if(page < 1){
        page = 1;
      }
    }else{
      page = (length / 10) + 1;
    }
    if(!environment.production) console.log('page', length, residue, page);
    this.notificationService.getNotifications(page);
  }

  onViewAllNotifications(){
    this.router.navigateByUrl("/alarms");
    this.notificationService.showNavNotifications = !this.notificationService.showNavNotifications;
  }

  //lee los clics de la pantalla y si se hacen fuer a de lo relevante a notificaciones, se cierra el scroll de notificaciones
  @HostListener('document:click', ['$event'])
  onDocumentClick(event: MouseEvent) {
    const targetElement = event.target as HTMLElement;
  
    // checa si el clic fue dentro de algun elemento de las notificaciones
    const isNotificationsButtonClicked = targetElement.classList.contains('nav-notification') || 
                                          targetElement.classList.contains('nav-notification-button') || 
                                          targetElement.classList.contains('nav-notification-img') ||
                                          targetElement.classList.contains('notification-item-text') ||
                                          targetElement.classList.contains('notification-item-title') ||
                                          targetElement.classList.contains('notification-item-description') ||
                                          targetElement.classList.contains('notification-item-date') ||
                                          targetElement.classList.contains('notification-icon') ||
                                          targetElement.classList.contains('notificationIconBg') ||
                                          targetElement.classList.contains('notificationImg') ||
                                          targetElement.classList.contains('cdk-overlay-backdrop') ||
                                          targetElement.classList.contains('notifications-container');
    
                                      
    const insideAlarmPopup = !!targetElement.closest('.alarm-container');
    
    if (!isNotificationsButtonClicked && !insideAlarmPopup) {
      // if(!environment.production) console.log("hide notifications", targetElement);
      
      this.notificationService.showNavNotifications = false;
    }
    
  }
}
